import { useContext } from 'react';
import { X, File, Folder, LayoutGrid } from 'lucide-react';
import { cn } from '@/lib/cn';
import NotificationContext from '@/context/notification';

interface SelectedItem {
  id?: string;
  name?: string;
  title?: string;
  itemtype?: string;
  type?: string;
}

interface SelectedItemTagsProps {
  items: SelectedItem[];
  onRemove: (items: SelectedItem[]) => void;
}

function getIcon(item: SelectedItem) {
  switch (item.itemtype) {
    case 'folder':
      return Folder;
    case 'project':
      return LayoutGrid;
    default:
      return File;
  }
}

export function SelectedItemTags({ items, onRemove }: SelectedItemTagsProps) {
  const { add } = useContext(NotificationContext);

  const handleRemove = (item: SelectedItem) => {
    if (items.length <= 1) {
      add({ id: Date.now(), type: 'info', message: "Can't remove only item" });
      return;
    }
    onRemove([item]);
  };

  return (
    <div className="flex flex-wrap gap-1.5">
      {items.map((item) => {
        const label = item.title || item.name || 'Untitled';
        const Icon = getIcon(item);

        return (
          <span
            key={item.id ?? label}
            className={cn(
              'inline-flex max-w-48 items-center gap-1.5 rounded-full',
              'border border-border bg-secondary py-1 px-2  text-sm text-accent-foreground',
            )}
          >
            <Icon className="h-4 w-4 shrink-0 text-muted-foreground" />
            <span className="truncate">{label}</span>
            {items.length > 1 && (
              <button
                type="button"
                onClick={() => handleRemove(item)}
                className="shrink-0 rounded-full p-0.5 text-muted-foreground hover:bg-accent hover:text-muted-foreground"
              >
                <X className="h-3 w-3" />
              </button>
            )}
          </span>
        );
      })}
    </div>
  );
}
